import {EAgentPaymentsTab} from 'src/containers/Agent';

export default {
  emptyReports: {
    subtitle: 'You don’t have any paying clients yet',
    action: 'To client list',
  },
  emptyDocuments: {
    title: 'No documents',
    subtitle: 'No documents were generated for the reporting period',
  },
  allEmpty: {
    subtitle: 'You don’t have any paying clients yet',
    action: 'To client list',
  },
  tabs: {
    [EAgentPaymentsTab.REPORT]: 'Summary',
    [EAgentPaymentsTab.DOCUMENTS]: 'Reporting documents',
  },
  payments: {
    found: 'Payments',
    search: 'quick search by client',
    period: 'Select reporting period',
    date: 'Payment date',
    periodResult: 'Result for the period',
    commissionPercentage: 'Your agent commission rate',
    paymentsAmount: 'Total payments for the selected period',
    commissionAmount: 'Total commission for the period',
    allPayments: 'Total payments',
    approximateAward: 'Preliminary commission amount',
    awardHint: 'The exact commission amount will be confirmed by your manager',
    downloadReport: 'Export list',
    license: 'License {{name}}',
    whatsAppNumberConnection: 'Connection of a WhatsApp phone number',
    th: {
      date: 'Payment date',
      companyName: 'Client name',
      taxNumber: 'Client tax ID',
      payment: 'Payment name',
      amount: 'Payment amount excluding VAT',
      commission: 'Commission amount',
    },
    quarter: 'Quarter',
  },
  documents: {
    info: 'This section contains the final reports for the previous reporting period. You can use them to create a statement report: download the form, add the commission calculation, and specify your VAT amount.',
    th: {
      createdAt: 'Date of creation',
      fileName: 'Document name',
    },
    download: 'Download',
    name: 'Statement report for {{period}} {{year}}',
    noData: {
      title: 'No documents',
      subtitle: 'No documents were generated for the reporting period',
    },
  },
};
